import React, { createContext, useContext } from 'react'

export type ControlType<T> = {
    ref: React.RefObject<T>
}

export type ControlContextValueType = {
    addInputRef<T>(ref: React.RefObject<T>): void
    id: string
    updateControlValue: (value: string | string[] | number) => void
    isRegistered: boolean
}

export const ControlContext = createContext<ControlContextValueType | undefined>(undefined)

export const useControl = () => {
    const control = useContext(ControlContext)
    return control
}

export const ControlProvider = ControlContext.Provider
